import React, {useState} from "react";
import styles from './Button.module.scss'

const Button = ({ title, block=false, onClick, type = 'primary', size = 'medium', textSize = 'textMedium', active = false, disabled = false, height = 'large', color, activeColor }) => {

  const [isHover, setIsHover] = useState(false)

  return (
    <button
        onClick={onClick}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        style={type === "outline" ? { borderColor: color, color: color, backgroundColor: isHover ? color : "transparent" } : { backgroundColor: active && activeColor ? activeColor : color }}
        className={
            [
                styles.Button,
                styles[type],
                styles[size],
                styles[textSize],
                styles[`height${height}`],
                (block ? styles.block : ''),
                (disabled ? styles.disabled : ''),
                (active ? styles.active : '')
            ].join(' ')}>
      <div>{ title }</div>
    </button>
  )
};

export default Button;